import { render, staticRenderFns } from "./MateDelivery.vue?vue&type=template&id=0c5fd9e9&scoped=true"
import script from "./MateDelivery.vue?vue&type=script&lang=js"
export * from "./MateDelivery.vue?vue&type=script&lang=js"
import style0 from "./MateDelivery.vue?vue&type=style&index=0&id=0c5fd9e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5fd9e9",
  null
  
)

export default component.exports